import {
  Disposition_Status_Type,
  LoginDataType,
  MessageType,
  OneToOneMessageType,
  UserNumberPinType,
} from "../type";
import HttpService from "./interceptors";
import { delay } from "../../helper/delayresponse";
import { values } from "lodash";
//Login API
export const LoginApi = async (values: LoginDataType) =>
  await HttpService.post("/api/users/login", values);

//User Dashboard API
export const UserDashboardApi = async () =>
  await HttpService.get("/api/users/dashboard");
export const UserCampaignListApi = async () =>
  await HttpService.get("/api/users/campaigns");
export const UserDashboardChartApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/dashboard/chart?campaign_id=${queryKey[1] ? queryKey[1] : ""}`
  );
export const UserCampaignNumbersApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/dashboard/list?campaign_id=${queryKey[1] ? queryKey[1] : ""}`
  );

//Chat Box
export const CreateMessageApi = async (values: MessageType) => {
  const formData = new FormData();
  formData.append("campaignId", values.campaignId.toString());
  formData.append("appendID", values.appendID.toString());
  formData.append("message", values.message.toString());
  formData.append("number", values.number.toString());
  formData.append("type", values.type.toString());
  if (values.media && values?.media.length > 0) {
    for (let i = 0; i < values.media.length; i++)
      formData.append("media", values.media[i]);
  }

  return await HttpService.post("/api/users/create-message", formData);
};

export const OneToOneMessageAPI = async (values: OneToOneMessageType) => {
  const formData = new FormData();
  formData.append("campaignId", values.campaignId.toString());
  formData.append("appendID", values.appendID.toString());
  formData.append("message", values.message.toString());
  formData.append("number", values.number.toString());
  formData.append("type", values.type.toString());
  formData.append("from_number", values.from_number.toString());
  if (values.media && values?.media.length > 0) {
    for (let i = 0; i < values.media.length; i++)
      formData.append("media", values.media[i]);
  }

  return await HttpService.post(
    "/api/users/one-to-one/create-message",
    formData
  );
};

export const ShortcutMessagesApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/shortcut-messages?search=${queryKey[1] || ""}&campaign_id=${
      queryKey[2] || ""
    }`
  );
export const RetryMessageApi = async (data: { sms_id: number }) => {
  await delay(1000);
  const response = await HttpService.post("/api/users/retry-message", data);
  return response;
};

export const MessageDetailsApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/message-details?sms_id=${queryKey[1] || ""}`
  );

export const SearchNumberMessageApi = async ({ queryKey }: any) => {
  return await HttpService.get(
    `/api/users/number-and-messages?search=${queryKey[1] || ""}&campaign_id=${
      queryKey[2] || ""
    }&limit=${queryKey[3] || ""}&page=${queryKey[4] || ""}&isunread=${
      queryKey[5]
    }`
  );
};
export const CampaignNumbersApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/get-campaign-number?campaign_id=${queryKey[1] || ""}`
  );
export const BlocklistNumbersApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/blocklist/numbers?search=${queryKey[1] || ""}&page=${
      queryKey[2] || ""
    }&campaign_id=${queryKey[3]}`
  );
export const CreateBlocklistApi = async (v: {
  number: string;
  campaign_id: string;
}) => await HttpService.post(`/api/users/blocklist/create`, v);
export const RemoveBlocklistApi = async (v: {
  number: string;
  campaign_id: string;
}) =>
  await HttpService.delete(
    `/api/users/blocklist/delete/${v.number}?campaign_id=${v.campaign_id}`
  );

//is Monitor
export const isMonitorApi = async () =>
  await HttpService.get("/api/users/is-monitor");

//Monitor API
export const MonitorDashboardApi = async () =>
  await HttpService.get("/api/users/monitor/dashboard");
export const MonitorDashboardCampaignChartApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/monitor/dashboard/chart/campaign?campaignId=${
      queryKey[1] ? queryKey[1] : ""
    }`
  );
export const MonitorDashboardAgentChartApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/monitor/dashboard/chart/agent?user_id=${
      queryKey[1] ? queryKey[1] : ""
    }`
  );
export const UserListApi = async ({ queryKey }: any) => {
  let q = `search=${queryKey[1]?.search || ""}`;
  q += `&is_pagination=${queryKey[1]?.is_pagination || false}`;
  q += `&page=${queryKey[1]?.page || 1}`;
  q += `&campaign_id=${queryKey[1]?.campaign_id || ""}`;

  return await HttpService.get(`/api/users/user-list?${q}`);
};

//Report
export const AgentWiseReportApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/agent-unique-customer?page=${queryKey[1]}&limit=10&to=${
      queryKey[2]?.to?.replaceAll("+", "%2B") || ""
    }&user_id=${queryKey[2]?.user_id || ""}&total_sms=${
      queryKey[2]?.total_sms || ""
    }&sms_campaign.name=${queryKey[2]?.campaign_name || ""}&from_date=${
      queryKey[2]?.from_date || ""
    }&to_date=${queryKey[2]?.to_date || ""}`
  );
export const HistroyReportApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/sms-history?page=${queryKey[1]}&limit=10&message_type=${
      queryKey[2]?.message_type || ""
    }&to=${queryKey[2]?.to?.replaceAll("+", "%2B") || ""}&direction=${
      queryKey[2]?.direction || ""
    }&status=${queryKey[2]?.status || ""}&from_date=${
      queryKey[2]?.from_date || ""
    }&to_date=${queryKey[2]?.to_date || ""}`
  );
export const SMSConversionReportApi = async ({ queryKey }: any) =>
  await HttpService.get(`/api/users/reports/sms-conversion`);

export const AgentWiseReportDownloadApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/agent-unique-customer/download?to=${
      queryKey[2]?.to?.replaceAll("+", "%2B") || ""
    }&user_id=${queryKey[2]?.user_id || ""}&total_sms=${
      queryKey[2]?.total_sms || ""
    }&sms_campaign.name=${queryKey[2]?.campaign_name || ""}&from_date=${
      queryKey[2]?.from_date || ""
    }&to_date=${queryKey[2]?.to_date || ""}`,
    { responseType: "blob" }
  );
export const HistroyReportDownloadApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/sms-history/download?message_type=${
      queryKey[2]?.message_type || ""
    }&to=${queryKey[2]?.to?.replaceAll("+", "%2B") || ""}&direction=${
      queryKey[2]?.direction || ""
    }&status=${queryKey[2]?.status || ""}&from_date=${
      queryKey[2]?.from_date || ""
    }&to_date=${queryKey[2]?.to_date || ""}`,
    { responseType: "blob" }
  );

export const OneToOneReportApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/one-to-one/${queryKey[1]}?page=${queryKey[2]}&number=${
      queryKey[3]?.number?.replaceAll("+", "%2B") || ""
    }&user_id=${queryKey[3]?.user_id || ""}`
  );
export const DownloadOneToOneReportApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/one-to-one/download/${queryKey[1]}?number=${
      queryKey[3]?.number?.replaceAll("+", "%2B") || ""
    }&user_id=${queryKey[3]?.user_id || ""}`,
    { responseType: "blob" }
  );

export const CampaignWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${queryKey[3]?.status ? queryKey[3]?.status.join(",") : ""}`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id ? queryKey[3]?.user_id.join(",") : ""}`;

  return await HttpService.get(
    `/api/users/reports/campaign-wise/${queryKey[1]}${q}`
  );
};
export const DownloadCampaignWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${queryKey[3]?.status ? queryKey[3]?.status.join(",") : ""}`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id ? queryKey[3]?.user_id.join(",") : ""}`;

  return await HttpService.get(
    `/api/users/reports/campaign-wise/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const DispositionReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&number=${queryKey[3]?.number?.replaceAll("+", "%2B")}`;
  q += `&status=${queryKey[3]?.status || ""}`;
  q += `&user_name=${queryKey[3]?.user_name || ""}`;
  q += `&campaign_name=${queryKey[3]?.campaign_name || ""}`;

  return await HttpService.get(
    `/api/users/reports/disposition-number/${queryKey[1]}${q}`
  );
};

export const DispositionReportViewApi = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/reports/disposition-number-wise/${queryKey[1] || ""}`
  );

export const DownloadDispositionReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&number=${queryKey[3]?.number?.replaceAll("+", "%2B")}`;
  q += `&status=${queryKey[3]?.status || ""}`;
  q += `&user_name=${queryKey[3]?.user_name || ""}`;
  q += `&campaign_name=${queryKey[3]?.campaign_name || ""}`;

  return await HttpService.get(
    `/api/users/reports/disposition-number/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const CustomerWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&number=${queryKey[3]?.number?.replaceAll("+", "%2B")}`;
  q += `&Delivered=${queryKey[3]?.Delivered || ""}`;
  q += `&Undelivered=${queryKey[3]?.Undelivered || ""}`;
  q += `&Replied=${queryKey[3]?.Replied || ""}`;

  return await HttpService.get(
    `/api/users/reports/customer-wise/${queryKey[1]}${q}`
  );
};
export const DownloadCustomerWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&number=${queryKey[3]?.number?.replaceAll("+", "%2B")}`;
  q += `&Delivered=${queryKey[3]?.Delivered || ""}`;
  q += `&Undelivered=${queryKey[3]?.Undelivered || ""}`;
  q += `&Replied=${queryKey[3]?.Replied || ""}`;

  return await HttpService.get(
    `/api/users/reports/customer-wise/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const OutgoingAndIncomingReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&Incoming=${queryKey[3]?.Incoming || ""}`;
  q += `&Outgoing=${queryKey[3]?.Outgoing || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/outgoing-and-incoming/${queryKey[1]}${q}`
  );
};
export const DownloadOutgoingAndIncomingReportApi = async ({
  queryKey,
}: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&Incoming=${queryKey[3]?.Incoming || ""}`;
  q += `&Outgoing=${queryKey[3]?.Outgoing || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/outgoing-and-incoming/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const DayWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&Delivered=${queryKey[3]?.Delivered || ""}`;
  q += `&Sent=${queryKey[3]?.Sent || ""}`;
  q += `&Received=${queryKey[3]?.Received || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/day-wise/${queryKey[1]}${q}`
  );
};
export const DownloadDayWiseReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&Delivered=${queryKey[3]?.Delivered || ""}`;
  q += `&Sent=${queryKey[3]?.Sent || ""}`;
  q += `&Received=${queryKey[3]?.Received || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/day-wise/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const AgentWiseSecondReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${
    queryKey[3]?.status || queryKey[3]?.status === 0 ? queryKey[3]?.status : ""
  }`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id || ""}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise/${queryKey[1]}${q}`
  );
};
export const DownloadAgentWiseSecondReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${
    queryKey[3]?.status || queryKey[3]?.status === 0 ? queryKey[3]?.status : ""
  }`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id || ""}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

export const AgentWiseUniqueCustomerReportApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise-unique-customer/${queryKey[1]}${q}`
  );
};
export const DownloadAgentWiseUniqueCustomerReportApi = async ({
  queryKey,
}: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise-unique-customer/download/${queryKey[1]}${q}`,
    { responseType: "blob" }
  );
};

//Campaign List
export const SMSCampaignList = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/sms-campaign-list?limit=10&page=${queryKey[1]}&search=${queryKey[2]}`
  );

// =====pin-chat====
export const UserNumberPin = async (values: UserNumberPinType) =>
  await HttpService.post(`/api/users/usernumberpin/create`, values);
export const UserNumberPinDelete = async (values: UserNumberPinType) =>
  await HttpService.delete(`/api/users/usernumberpin/delete`, { data: values });

// =======disposition-status======
export const Disposition_StatusList = async ({ queryKey }: any) =>
  await HttpService.get(
    `/api/users/disposition-status-list?search=${queryKey[1] || ""}&page=${
      queryKey[2] || ""
    }`
  );
export const Disposition_StatusList_Add = async (
  values: Disposition_Status_Type
) => await HttpService.put(`/api/users/disposition-status/add`, values);
export const Disposition_Number_Wise_List = async ({ queryKey }: any) => {
  const encodedNumber = encodeURIComponent(queryKey[1] || ""); // Encode the number
  const campaignId = queryKey[2] || "";

  return await HttpService.get(
    `api/users/number-wise-disposition-status/list?number=${encodedNumber}&campaign_id=${campaignId}`
  );
};

export const AgentPinChatsListApi = async ({ queryKey }: any) => {
  let q = `search=${
    queryKey[1]?.search ? encodeURIComponent(queryKey[1]?.search) : ""
  }`;
  q += `&page=${queryKey[1]?.page || 1}`;
  q += `&campaign_id=${queryKey[1]?.campaign_id || ""}`;
  q += `&agent_id=${queryKey[1]?.agent_id || ""}`;

  return await HttpService.get(`/api/users/reports/agent-wise-pin-chat?${q}`);
};

export const SMSConversionReportTwoApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&campaign_id=${queryKey[1]?.campaign_id || ""}`;
  q += `&number=${encodeURIComponent(queryKey[1]?.number) || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${queryKey[3]?.status ? queryKey[3]?.status.join(",") : ""}`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id ? queryKey[3]?.user_id.join(",") : ""}`;
  q += `&is_pagination=${queryKey[1]?.is_pagination ? true : false}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise-conversion${q}`
  );
};
export const DownloadSMSConversionReportTwoApi = async ({ queryKey }: any) => {
  let q = `?page=${queryKey[2] || ""}`;
  q += `&campaign_id=${queryKey[1]?.campaign_id || ""}`;
  q += `&number=${encodeURIComponent(queryKey[1]?.number) || ""}`;
  q += `&message_type=${queryKey[3]?.message_type || ""}`;
  q += `&from=${queryKey[3]?.from?.replaceAll("+", "%2B") || ""}`;
  q += `&to=${queryKey[3]?.to?.replaceAll("+", "%2B") || ""}`;
  q += `&direction=${queryKey[3]?.direction || ""}`;
  q += `&status=${queryKey[3]?.status ? queryKey[3]?.status.join(",") : ""}`;
  q += `&sms_gateway_name=${queryKey[3]?.sms_gateway_name || ""}`;
  q += `&retry_sms_id=${queryKey[3]?.retry_sms_id || ""}`;
  q += `&error_code=${queryKey[3]?.error_code || ""}`;
  q += `&from_date=${queryKey[3]?.from_date || ""}`;
  q += `&to_date=${queryKey[3]?.to_date || ""}`;
  q += `&user.id=${queryKey[3]?.user_id ? queryKey[3]?.user_id.join(",") : ""}`;

  return await HttpService.get(
    `/api/users/reports/agent-wise-conversion/download${q}`,
    { responseType: "blob" }
  );
};

export const AgentWiseConversionReportApi = async ({ queryKey }: any) => {
  let q = `campaign_id=${queryKey[1]?.campaign_id || ""}`;
  q += `&number=${queryKey[1]?.number || ""}`;

  return await HttpService.get(`?${q}`);
};
